if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let h = this.getBoundingClientRect().top;
        if (h <= 0) {
          this.classList.add('is-sticky');
        } else {
          this.classList.remove('is-sticky');
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      if (isOpen) {
        detailsElement.classList.remove('submenu-open');
      } else {
        detailsElement.classList.add('submenu-open');
      }
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('submenu-open');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}



function headerScreen() {
  var headerSecreenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  var headerButtonLeft = document.querySelector('.header-full-menu-coustom2-left');
  var headerButtonRight = document.querySelector('.header-full-menu-coustom2-right');
  
  headerButtonLeft.classList.add('header_dis_none');
  if (headerSecreenWidth < 1580 && 1068 < headerSecreenWidth) {
      headerButtonRight.classList.add('header_dis_block');
      headerButtonRight.classList.remove('header_dis_none');
      headerButtonLeft.classList.remove('dis_none')
      // console.log('小于1580');
  }  else {
      headerButtonRight.classList.add('header_dis_none');
      headerButtonRight.classList.remove('header_dis_block');
      headerButtonLeft.classList.add('dis_none')
      // console.log('大于1580');
  }
}

headerScreen();

window.addEventListener('resize', headerScreen);

var headerButtonClickRight = document.querySelector('.header-full-menu-coustom2-right')
var headerButtonClickLeft = document.querySelector('.header-full-menu-coustom2-left')
var headerFullMenu = document.querySelector('.header-full-menu-coustom2 .full-menu ')
var headerFullMenuUlLi = document.querySelectorAll('.header-full-menu-coustom2 .full-menu .fristLi')


headerButtonClickRight.addEventListener('click',()=>{
  // console.log('点点点');
  headerFullMenu.classList.add('header-full-menu-transform')
  headerButtonClickRight.style.display = 'none';
  headerButtonClickLeft.classList.remove('header_dis_none')
  headerButtonClickLeft.style.display = 'block'
  headerButtonRightMenuLeft()

})
headerButtonClickLeft.addEventListener('click',()=>{
  
  headerFullMenu.classList.remove('header-full-menu-transform')
  headerButtonClickRight.style.display = 'block';
  headerButtonClickLeft.classList.add('header_dis_none')
  headerButtonClickLeft.style.display = 'none'
  
  headerButtonRightMenuRight()
 
  
})


// 点击 右边导航轮播 倒数三个li 二级类名向右偏移
function headerButtonRightMenuLeft() {
  
  // 获取倒数第二个和倒数第三个元素的索引
  var fristLastIndex = headerFullMenuUlLi.length - 1;
  var secondLastIndex = headerFullMenuUlLi.length - 2;
  var thirdLastIndex = headerFullMenuUlLi.length - 3;
  
  headerFullMenuUlLi.forEach((item, index) => {
    item.addEventListener('mouseover', () => {
      // 如果当前元素是倒数第二个或倒数第三个，则执行操作
      if (index === secondLastIndex || index === thirdLastIndex) {
        // console.log('111');
        // 这里可以添加其他你想要执行的操作
        var subMenuPl = document.querySelectorAll('.sub-menu-pl');
        subMenuPl.forEach(subMenu => {
          subMenu.style.transform = 'translateX(11%)';
        });
      }
      if(index === fristLastIndex ){
        var sumMenuFristLast = document.querySelectorAll('.sub-menu');
        sumMenuFristLast.forEach(submentfristlast2 => {
          // submentfristlast2.style.transform = 'translateX(-50%)';
          submentfristlast2.style.transform = 'translateX(12%)';

          submentfristlast2.classList.add('p-d-r-8r');
        })
      }
    });
  });
}

// 点击 导航轮播   所有二级类目盒子恢复
function headerButtonRightMenuRight() {


  
  headerFullMenuUlLi.forEach((item, index) => {

    item.addEventListener('mouseover', () => {
      // 如果当前元素是倒数第二个或倒数第三个，则执行操作
        // console.log('111');
        // 这里可以添加其他你想要执行的操作
        var subMenuPl = document.querySelectorAll('.sub-menu-pl');
        subMenuPl.forEach(subMenu => {
          subMenu.style.transform = 'translateX(0%)';
          // console.log('获取到 往左');
        });

      if(index === fristLastIndex ){
        var sumMenuFristLast = document.querySelectorAll('.sub-menu');
        sumMenuFristLast.forEach(submentfristlast2 => {
          submentfristlast2.style.transform = 'translateX(50%)';
          submentfristlast2.classList.remove('p-d-r-8r');
        })
      }
    });
  });
}




// // 点击左侧按钮恢复右移效果
// function headerButtonRightMenuRight() {
//   var subMenuPl = document.querySelectorAll('.sub-menu');
//   subMenuPl.forEach(subMenu => {
//     subMenu.style.transform = 'translateX(-50%)';
//     var subMenuPll = document.querySelector('.sub-menu-pl')
//     subMenuPll.style.transform = 'translateX(0%)';
//     subMenu.classList.remove('p-d-r-8r');
    
//   });
// }


// 偏移end
// function headerButtonRightMenuRight(){
//     // 获取倒数第二个和倒数第三个元素的索引
//     var secondLastIndex = headerFullMenuUlLi.length - 2;
//     var thirdLastIndex = headerFullMenuUlLi.length - 3;
    
//     headerFullMenuUlLi.forEach((item, index) => {
//       item.addEventListener('mouseover', () => {
//         // 如果当前元素是倒数第二个或倒数第三个，则执行操作
//         if (index === secondLastIndex || index === thirdLastIndex) {
//           console.log('111');
//           // 这里可以添加其他你想要执行的操作
//           var subMenuPl = document.querySelectorAll('.sub-menu-pl');
//           subMenuPl.forEach(subMenu => {
//             subMenu.style.transform = 'translateX(10%)';
//           });
//         }
      
//       });
//     });
// }










// 判断导航栏地址 添加样式
var fullUrl = window.location.href;
// console.log(fullUrl);

var conditions = [
  // { url: 'https://www.qvr.com/', title: 'QVR HAIR' },
  { url: 'https://www.qvr.com/collections/all-human-hair', title: 'QVR HAIR' },
  { url: 'https://www.qvr.com/pages/vip-center-2', title: 'QVR CLUB' },
  { url: 'https://www.qvr.com/pages/whatsapp', title: 'WIN FREE WIG' },
  { url: 'https://www.qvr.com/pages/get-inspired', title: 'GET INSPIRED' }
];

conditions.forEach(condition => {
  if (fullUrl === condition.url) {
    // console.log('或者打印: ' + condition.title);
    var headerLeftMenuLi = document.querySelectorAll('.header-left-menu .thb-full-menu li');
    headerLeftMenuLi.forEach(li => {
      var liA = li.querySelector('a');
      var titleA = liA.textContent.trim();
      if (titleA === condition.title) {
        liA.style.borderBottom = '2px solid #000';
      }
    });
  }
});




  // window.addEventListener('scroll', function() {
  //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //   var box = document.getElementById('box');
  //   var boxTop = box.getBoundingClientRect().top;
  //   var newPosition = scrollTop + boxTop;
  //   box.style.top = newPosition + 'px';
  // });
